import TransportType from './types/TransportType';
import { getFullUserName } from './getFullUserName';

export const transportTypeDescriptionMap = {
  [TransportType.EMAIL]: 'Email',
  [TransportType.EMAIL_SMS]: 'Send email-to-sms to',
  [TransportType.IN_APP]: 'Send mobile push notification to',
  [TransportType.DEVICE]: '',
  [TransportType.WEBHOOK]: 'Send HTTP Post to',
  [TransportType.SMS]: 'Text',
};

const NotificationGroupUtility = {
  //
  getRecipientsByTransportTypeId: (recipients, transportId) => recipients
    .filter((recipient) => recipient.transportId === transportId),
  // transport types not included are not enabled for actions
  // or can only be for users and we display username

  getContextStringByTransportTypeId: (transportTypeId, context) => {
    const parsed = NotificationGroupUtility.safeParse(context);
    switch (parseInt(transportTypeId, 10)) {
      case TransportType.EMAIL:
        return parsed.emailAddress || '';
      // case TransportType.EMAIL_SMS:
      //   return parsed.number || '';
      case TransportType.WEBHOOK:
        return parsed.url || '';
      default:
        return '';
    }
  },
  // takes recipients array , sorts to object map by transport type
  sortRecipientsByTransportType: (recipients) => recipients.reduce((buckets, recipient) => {
    const { transportId } = recipient;
    if (!buckets[transportId]) {
      buckets[transportId] = [];
    }
    buckets[transportId].push(recipient);
    return buckets;
  }, {}),
  // loops over each transportType collection from the sorted recipient map,
  // then loops over each recipient to create an array of recipient detail strings
  getRecipientDetailsStringArray: (recipientsToSort, users) => Object
    .entries(NotificationGroupUtility
      .sortRecipientsByTransportType(recipientsToSort))
    .map(([transportTypeId, recipients]) => {
      const recipientStringArray = recipients.map((recipient) => (recipient.userId !== null
        ? `${getFullUserName(recipient.userId, users)}`
        : `${NotificationGroupUtility.getContextStringByTransportTypeId(transportTypeId, recipient.context)}`));
      return `${transportTypeDescriptionMap[transportTypeId]} ${recipientStringArray.join(', ')} `;
    }),

  safeParse: (context) => {
    try {
      return JSON.parse(context || '{}');
    } catch (e) {
      return (
        {
          emailAddress: '',
          number: '',
          url: '',
        }
      );
    }
  },
};

export default NotificationGroupUtility;
